// Utility do zarządzania teksturami płytek z folderu textures/Kostki
// Ten plik jest automatycznie generowany przez scripts/generate-tile-textures.js
// NIE EDYTUJ TEGO PLIKU RĘCZNIE!

export interface TileVariant {
  id: string
  name: string
  texturePath: string
  fileName: string
}

export interface TileColor {
  id: string
  name: string
  variants: TileVariant[]
}

export interface TileModel {
  id: string
  name: string
  colors: TileColor[]
}

// Lista wszystkich modeli i ich tekstur
export const tileModels: TileModel[] = [
  {
    id: "aprilia",
    name: "Aprilia",
    colors: [
      {
        id: "aprilia-falista-mix-a4-czekolada",
        name: "Falista Mix A4 Czekolada",
        variants: [
          {
            id: "aprilia-falista-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia falista mix A4 czekolada.jpg",
            fileName: "Aprilia falista mix A4 czekolada.jpg"
          }
        ]
      },
      {
        id: "aprilia-falista-mix-a5-toffi",
        name: "Falista Mix A5 Toffi",
        variants: [
          {
            id: "aprilia-falista-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia falista mix A5 toffi.jpg",
            fileName: "Aprilia falista mix A5 toffi.jpg"
          }
        ]
      },
      {
        id: "aprilia-falista-mix-a6-marago",
        name: "Falista Mix A6 Marago",
        variants: [
          {
            id: "aprilia-falista-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia falista mix A6 marago.jpg",
            fileName: "Aprilia falista mix A6 marago.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "aprilia-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A10 Romano.jpg",
            fileName: "Aprilia mix A10 Romano.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a11-cappuchino",
        name: "Mix A11 Cappuchino",
        variants: [
          {
            id: "aprilia-mix-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A11 Cappuchino.jpg",
            fileName: "Aprilia mix A11 Cappuchino.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "aprilia-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A12 Frappe.jpg",
            fileName: "Aprilia mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a4-czekolada",
        name: "Mix A4 Czekolada",
        variants: [
          {
            id: "aprilia-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A4 czekolada.jpg",
            fileName: "Aprilia mix A4 czekolada.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a5-toffi",
        name: "Mix A5 Toffi",
        variants: [
          {
            id: "aprilia-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A5 toffi.jpg",
            fileName: "Aprilia mix A5 toffi.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "aprilia-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A6 Marago.jpg",
            fileName: "Aprilia mix A6 Marago.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "aprilia-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A6 S.jpg",
            fileName: "Aprilia mix A6 S.jpg"
          }
        ]
      },
      {
        id: "aprilia-mix-a8-mocca",
        name: "Mix A8 Mocca",
        variants: [
          {
            id: "aprilia-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia mix A8 Mocca.jpg",
            fileName: "Aprilia mix A8 Mocca.jpg"
          }
        ]
      },
      {
        id: "aprilia-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "aprilia-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia standard biały.jpg",
            fileName: "Aprilia standard biały.jpg"
          }
        ]
      },
      {
        id: "aprilia-standard-espresso",
        name: "Standard Espresso",
        variants: [
          {
            id: "aprilia-standard-espresso-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia standard espresso.jpg",
            fileName: "Aprilia standard espresso.jpg"
          }
        ]
      },
      {
        id: "aprilia-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "aprilia-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia standard grafit.jpg",
            fileName: "Aprilia standard grafit.jpg"
          }
        ]
      },
      {
        id: "aprilia-standard-latte",
        name: "Standard Latte",
        variants: [
          {
            id: "aprilia-standard-latte-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia standard latte.jpg",
            fileName: "Aprilia standard latte.jpg"
          }
        ]
      },
      {
        id: "aprilia-standard-lungo",
        name: "Standard Lungo",
        variants: [
          {
            id: "aprilia-standard-lungo-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia standard lungo.jpg",
            fileName: "Aprilia standard lungo.jpg"
          }
        ]
      },
      {
        id: "aprilia-standard-szary",
        name: "Standard Szary",
        variants: [
          {
            id: "aprilia-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Aprilia/Aprilia standard szary.jpg",
            fileName: "Aprilia standard szary.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "bergamo",
    name: "Bergamo",
    colors: [
      {
        id: "bergamo-a10-romano",
        name: "A10 Romano",
        variants: [
          {
            id: "bergamo-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A10 Romano 1.jpg",
            fileName: "Bergamo A10 Romano 1.jpg"
          },
          {
            id: "bergamo-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A10 Romano 2.jpg",
            fileName: "Bergamo A10 Romano 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-a12-frappe",
        name: "A12 Frappe",
        variants: [
          {
            id: "bergamo-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A12 Frappe 1.jpg",
            fileName: "Bergamo A12 Frappe 1.jpg"
          },
          {
            id: "bergamo-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A12 Frappe 2.jpg",
            fileName: "Bergamo A12 Frappe 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-a6-marago",
        name: "A6 Marago",
        variants: [
          {
            id: "bergamo-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A6 Marago 1.jpg",
            fileName: "Bergamo A6 Marago 1.jpg"
          },
          {
            id: "bergamo-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A6 Marago 2.jpg",
            fileName: "Bergamo A6 Marago 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-a6-s",
        name: "A6 S",
        variants: [
          {
            id: "bergamo-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A6 S 1.jpg",
            fileName: "Bergamo A6 S 1.jpg"
          },
          {
            id: "bergamo-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A6 S 2.jpg",
            fileName: "Bergamo A6 S 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-a8-mocca",
        name: "A8 Mocca",
        variants: [
          {
            id: "bergamo-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A8 Mocca 1.jpg",
            fileName: "Bergamo A8 Mocca 1.jpg"
          },
          {
            id: "bergamo-a8-mocca-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo A8 Mocca 2.jpg",
            fileName: "Bergamo A8 Mocca 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "bergamo-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo standard Biały 1.jpg",
            fileName: "Bergamo standard Biały 1.jpg"
          },
          {
            id: "bergamo-standard-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo standard Biały 2.jpg",
            fileName: "Bergamo standard Biały 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "bergamo-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo standard Grafit 1.jpg",
            fileName: "Bergamo standard Grafit 1.jpg"
          },
          {
            id: "bergamo-standard-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo standard Grafit 2.jpg",
            fileName: "Bergamo standard Grafit 2.jpg"
          }
        ]
      },
      {
        id: "bergamo-standard-szary",
        name: "Standard Szary",
        variants: [
          {
            id: "bergamo-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Bergamo/Bergamo standard Szary 1.jpg",
            fileName: "Bergamo standard Szary 1.jpg"
          },
          {
            id: "bergamo-standard-szary-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Bergamo/Bergamo standard Szary 2.jpg",
            fileName: "Bergamo standard Szary 2.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "dakota",
    name: "Dakota",
    colors: [
      {
        id: "dakota-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "dakota-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A10 Romano (1).jpg",
            fileName: "Dakota mix A10 Romano (1).jpg"
          },
          {
            id: "dakota-mix-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A10 Romano (2).jpg",
            fileName: "Dakota mix A10 Romano (2).jpg"
          },
          {
            id: "dakota-mix-a10-romano-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A10 Romano (3).jpg",
            fileName: "Dakota mix A10 Romano (3).jpg"
          },
          {
            id: "dakota-mix-a10-romano-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A10 Romano (4).jpg",
            fileName: "Dakota mix A10 Romano (4).jpg"
          }
        ]
      },
      {
        id: "dakota-mix-a11-cappuchino",
        name: "Mix A11 Cappuchino",
        variants: [
          {
            id: "dakota-mix-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A11 Cappuchino (1).jpg",
            fileName: "Dakota mix A11 Cappuchino (1).jpg"
          },
          {
            id: "dakota-mix-a11-cappuchino-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A11 Cappuchino (2).jpg",
            fileName: "Dakota mix A11 Cappuchino (2).jpg"
          },
          {
            id: "dakota-mix-a11-cappuchino-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A11 Cappuchino (3).jpg",
            fileName: "Dakota mix A11 Cappuchino (3).jpg"
          },
          {
            id: "dakota-mix-a11-cappuchino-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A11 Cappuchino (4).jpg",
            fileName: "Dakota mix A11 Cappuchino (4).jpg"
          }
        ]
      },
      {
        id: "dakota-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "dakota-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A12 Frappe (1).jpg",
            fileName: "Dakota mix A12 Frappe (1).jpg"
          },
          {
            id: "dakota-mix-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A12 Frappe (2).jpg",
            fileName: "Dakota mix A12 Frappe (2).jpg"
          },
          {
            id: "dakota-mix-a12-frappe-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A12 Frappe (3).jpg",
            fileName: "Dakota mix A12 Frappe (3).jpg"
          },
          {
            id: "dakota-mix-a12-frappe-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A12 Frappe (4).jpg",
            fileName: "Dakota mix A12 Frappe (4).jpg"
          }
        ]
      },
      {
        id: "dakota-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "dakota-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A6 S (1).jpg",
            fileName: "Dakota mix A6 S (1).jpg"
          },
          {
            id: "dakota-mix-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A6 S (2).jpg",
            fileName: "Dakota mix A6 S (2).jpg"
          },
          {
            id: "dakota-mix-a6-s-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A6 S (3).jpg",
            fileName: "Dakota mix A6 S (3).jpg"
          },
          {
            id: "dakota-mix-a6-s-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota mix A6 S (4).jpg",
            fileName: "Dakota mix A6 S (4).jpg"
          }
        ]
      },
      {
        id: "dakota-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "dakota-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Biały (1).jpg",
            fileName: "Dakota standard Biały (1).jpg"
          },
          {
            id: "dakota-standard-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Biały (2).jpg",
            fileName: "Dakota standard Biały (2).jpg"
          },
          {
            id: "dakota-standard-bialy-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Biały (3).jpg",
            fileName: "Dakota standard Biały (3).jpg"
          },
          {
            id: "dakota-standard-bialy-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Biały (4).jpg",
            fileName: "Dakota standard Biały (4).jpg"
          }
        ]
      },
      {
        id: "dakota-standard-espresso",
        name: "Standard Espresso",
        variants: [
          {
            id: "dakota-standard-espresso-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Espresso (1).jpg",
            fileName: "Dakota standard Espresso (1).jpg"
          },
          {
            id: "dakota-standard-espresso-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Espresso (2).jpg",
            fileName: "Dakota standard Espresso (2).jpg"
          },
          {
            id: "dakota-standard-espresso-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Espresso (3).jpg",
            fileName: "Dakota standard Espresso (3).jpg"
          },
          {
            id: "dakota-standard-espresso-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Espresso (4).jpg",
            fileName: "Dakota standard Espresso (4).jpg"
          }
        ]
      },
      {
        id: "dakota-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "dakota-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Grafit (1).jpg",
            fileName: "Dakota standard Grafit (1).jpg"
          },
          {
            id: "dakota-standard-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Grafit (2).jpg",
            fileName: "Dakota standard Grafit (2).jpg"
          },
          {
            id: "dakota-standard-grafit-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Grafit (3).jpg",
            fileName: "Dakota standard Grafit (3).jpg"
          },
          {
            id: "dakota-standard-grafit-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Grafit (4).jpg",
            fileName: "Dakota standard Grafit (4).jpg"
          }
        ]
      },
      {
        id: "dakota-standard-latte",
        name: "Standard Latte",
        variants: [
          {
            id: "dakota-standard-latte-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Latte (1).jpg",
            fileName: "Dakota standard Latte (1).jpg"
          },
          {
            id: "dakota-standard-latte-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Latte (2).jpg",
            fileName: "Dakota standard Latte (2).jpg"
          },
          {
            id: "dakota-standard-latte-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Latte (3).jpg",
            fileName: "Dakota standard Latte (3).jpg"
          },
          {
            id: "dakota-standard-latte-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Latte (4).jpg",
            fileName: "Dakota standard Latte (4).jpg"
          }
        ]
      },
      {
        id: "dakota-standard-lungo",
        name: "Standard Lungo",
        variants: [
          {
            id: "dakota-standard-lungo-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Lungo (1).jpg",
            fileName: "Dakota standard Lungo (1).jpg"
          },
          {
            id: "dakota-standard-lungo-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Lungo (2).jpg",
            fileName: "Dakota standard Lungo (2).jpg"
          },
          {
            id: "dakota-standard-lungo-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Lungo (3).jpg",
            fileName: "Dakota standard Lungo (3).jpg"
          },
          {
            id: "dakota-standard-lungo-4",
            name: "Wariant 4",
            texturePath: "/textures/Kostki/Dakota/Dakota standard Lungo (4).jpg",
            fileName: "Dakota standard Lungo (4).jpg"
          }
        ]
      }
    ]
  },
  {
    id: "esperia",
    name: "Esperia",
    colors: [
      {
        id: "esperia-a10-romano",
        name: "A10 Romano",
        variants: [
          {
            id: "esperia-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A10 Romano 1.jpg",
            fileName: "Esperia A10 Romano 1.jpg"
          },
          {
            id: "esperia-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A10 Romano 2.jpg",
            fileName: "Esperia A10 Romano 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a11-cappuchino",
        name: "A11 Cappuchino",
        variants: [
          {
            id: "esperia-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A11 Cappuchino 1.jpg",
            fileName: "Esperia A11 Cappuchino 1.jpg"
          },
          {
            id: "esperia-a11-cappuchino-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A11 Cappuchino 2.jpg",
            fileName: "Esperia A11 Cappuchino 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a12-frappe",
        name: "A12 Frappe",
        variants: [
          {
            id: "esperia-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A12 Frappe 1.jpg",
            fileName: "Esperia A12 Frappe 1.jpg"
          },
          {
            id: "esperia-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A12 Frappe 2.jpg",
            fileName: "Esperia A12 Frappe 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a4-czekolada",
        name: "A4 Czekolada",
        variants: [
          {
            id: "esperia-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A4 czekolada 1.jpg",
            fileName: "Esperia A4 czekolada 1.jpg"
          },
          {
            id: "esperia-a4-czekolada-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A4 czekolada 2.jpg",
            fileName: "Esperia A4 czekolada 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a5-toffi",
        name: "A5 Toffi",
        variants: [
          {
            id: "esperia-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A5 Toffi 1.jpg",
            fileName: "Esperia A5 Toffi 1.jpg"
          },
          {
            id: "esperia-a5-toffi-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A5 Toffi 2.jpg",
            fileName: "Esperia A5 Toffi 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a5-toffi-trawertyn",
        name: "A5 Toffi Trawertyn",
        variants: [
          {
            id: "esperia-a5-toffi-trawertyn-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A5 Toffi trawertyn 1.jpg",
            fileName: "Esperia A5 Toffi trawertyn 1.jpg"
          },
          {
            id: "esperia-a5-toffi-trawertyn-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A5 Toffi trawertyn 2.jpg",
            fileName: "Esperia A5 Toffi trawertyn 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a6-marago",
        name: "A6 Marago",
        variants: [
          {
            id: "esperia-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A6 Marago 1.jpg",
            fileName: "Esperia A6 Marago 1.jpg"
          },
          {
            id: "esperia-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A6 Marago 2.jpg",
            fileName: "Esperia A6 Marago 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a6-s",
        name: "A6 S",
        variants: [
          {
            id: "esperia-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A6 S 1.jpg",
            fileName: "Esperia A6 S 1.jpg"
          },
          {
            id: "esperia-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A6 S 2.jpg",
            fileName: "Esperia A6 S 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a6-s-trawertyn",
        name: "A6 S Trawertyn",
        variants: [
          {
            id: "esperia-a6-s-trawertyn-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A6 S trawertyn 1.jpg",
            fileName: "Esperia A6 S trawertyn 1.jpg"
          },
          {
            id: "esperia-a6-s-trawertyn-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A6 S trawertyn 2.jpg",
            fileName: "Esperia A6 S trawertyn 2.jpg"
          }
        ]
      },
      {
        id: "esperia-a8-mocca",
        name: "A8 Mocca",
        variants: [
          {
            id: "esperia-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia A8 Mocca 1.jpg",
            fileName: "Esperia A8 Mocca 1.jpg"
          },
          {
            id: "esperia-a8-mocca-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia A8 Mocca 2.jpg",
            fileName: "Esperia A8 Mocca 2.jpg"
          }
        ]
      },
      {
        id: "esperia-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "esperia-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Esperia/Esperia standard grafit 1.jpg",
            fileName: "Esperia standard grafit 1.jpg"
          },
          {
            id: "esperia-standard-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Esperia/Esperia standard grafit 2.jpg",
            fileName: "Esperia standard grafit 2.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "florencja",
    name: "Florencja",
    colors: [
      {
        id: "florencja-mix-a4-czekolada",
        name: "Mix A4 Czekolada",
        variants: [
          {
            id: "florencja-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Florencja/Florencja mix A4 Czekolada 1.jpg",
            fileName: "Florencja mix A4 Czekolada 1.jpg"
          }
        ]
      },
      {
        id: "florencja-mix-a5-toffi",
        name: "Mix A5 Toffi",
        variants: [
          {
            id: "florencja-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Florencja/Florencja mix A5 Toffi 1.jpg",
            fileName: "Florencja mix A5 Toffi 1.jpg"
          }
        ]
      },
      {
        id: "florencja-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "florencja-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Florencja/Florencja mix A6 Marago 1.jpg",
            fileName: "Florencja mix A6 Marago 1.jpg"
          }
        ]
      },
      {
        id: "florencja-mix-a8-mocca",
        name: "Mix A8 Mocca",
        variants: [
          {
            id: "florencja-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Florencja/Florencja mix A8 Mocca 1.jpg",
            fileName: "Florencja mix A8 Mocca 1.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "gardena",
    name: "Gardena",
    colors: [
      {
        id: "gardena-mix-a1-zlota-jesien",
        name: "Mix A1 Zlota Jesień",
        variants: [
          {
            id: "gardena-mix-a1-zlota-jesien-1",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Gardena/Gardena mix A1 Zlota Jesień 2.jpg",
            fileName: "Gardena mix A1 Zlota Jesień 2.jpg"
          },
          {
            id: "gardena-mix-a1-zlota-jesien-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Gardena/Gardena mix A1 Zlota Jesień.jpg",
            fileName: "Gardena mix A1 Zlota Jesień.jpg"
          }
        ]
      },
      {
        id: "gardena-mix-a5-toffi",
        name: "Mix A5 Toffi",
        variants: [
          {
            id: "gardena-mix-a5-toffi-1",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Gardena/Gardena mix A5 Toffi 2.jpg",
            fileName: "Gardena mix A5 Toffi 2.jpg"
          },
          {
            id: "gardena-mix-a5-toffi-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Gardena/Gardena mix A5 Toffi.jpg",
            fileName: "Gardena mix A5 Toffi.jpg"
          }
        ]
      },
      {
        id: "gardena-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "gardena-mix-a6-marago-1",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Gardena/Gardena mix A6 Marago 2.jpg",
            fileName: "Gardena mix A6 Marago 2.jpg"
          },
          {
            id: "gardena-mix-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Gardena/Gardena mix A6 Marago.jpg",
            fileName: "Gardena mix A6 Marago.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "genewa",
    name: "Genewa",
    colors: [
      {
        id: "genewa-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "genewa-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Genewa/Genewa mix A10 Romano 1.jpg",
            fileName: "Genewa mix A10 Romano 1.jpg"
          },
          {
            id: "genewa-mix-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Genewa/Genewa mix A10 Romano 2.jpg",
            fileName: "Genewa mix A10 Romano 2.jpg"
          }
        ]
      },
      {
        id: "genewa-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "genewa-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Genewa/Genewa mix A12 Frappe 1.jpg",
            fileName: "Genewa mix A12 Frappe 1.jpg"
          },
          {
            id: "genewa-mix-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Genewa/Genewa mix A12 Frappe 2.jpg",
            fileName: "Genewa mix A12 Frappe 2.jpg"
          }
        ]
      },
      {
        id: "genewa-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "genewa-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Genewa/Genewa mix A6 S 1.jpg",
            fileName: "Genewa mix A6 S 1.jpg"
          },
          {
            id: "genewa-mix-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Genewa/Genewa mix A6 S 2.jpg",
            fileName: "Genewa mix A6 S 2.jpg"
          }
        ]
      },
      {
        id: "genewa-standard-bialy",
        name: "Standard Bialy",
        variants: [
          {
            id: "genewa-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Genewa/Genewa standard bialy 1.jpg",
            fileName: "Genewa standard bialy 1.jpg"
          },
          {
            id: "genewa-standard-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Genewa/Genewa standard bialy 2.jpg",
            fileName: "Genewa standard bialy 2.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "grosseto",
    name: "Grosseto",
    colors: [
      {
        id: "grosseto-bialy-standard",
        name: "Biały Standard",
        variants: [
          {
            id: "grosseto-bialy-standard-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto biały standard 1.jpg",
            fileName: "Grosseto biały standard 1.jpg"
          },
          {
            id: "grosseto-bialy-standard-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto biały standard 2.jpg",
            fileName: "Grosseto biały standard 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-grafit",
        name: "Grafit",
        variants: [
          {
            id: "grosseto-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto grafit 1.jpg",
            fileName: "Grosseto grafit 1.jpg"
          },
          {
            id: "grosseto-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto grafit 2.jpg",
            fileName: "Grosseto grafit 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "grosseto-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A10 Romano 1.jpg",
            fileName: "Grosseto mix A10 Romano 1.jpg"
          },
          {
            id: "grosseto-mix-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A10 Romano 2.jpg",
            fileName: "Grosseto mix A10 Romano 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-mix-a11-capucino",
        name: "Mix A11 Capucino",
        variants: [
          {
            id: "grosseto-mix-a11-capucino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A11 Capucino 1.jpg",
            fileName: "Grosseto mix A11 Capucino 1.jpg"
          },
          {
            id: "grosseto-mix-a11-capucino-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A11 Capucino 2.jpg",
            fileName: "Grosseto mix A11 Capucino 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "grosseto-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A12 Frappe 1.jpg",
            fileName: "Grosseto mix A12 Frappe 1.jpg"
          },
          {
            id: "grosseto-mix-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A12 Frappe 2.jpg",
            fileName: "Grosseto mix A12 Frappe 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "grosseto-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A6 Marago 1.jpg",
            fileName: "Grosseto mix A6 Marago 1.jpg"
          },
          {
            id: "grosseto-mix-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A6 Marago 2.jpg",
            fileName: "Grosseto mix A6 Marago 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "grosseto-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A6 S 1.jpg",
            fileName: "Grosseto mix A6 S 1.jpg"
          },
          {
            id: "grosseto-mix-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A6 S 2.jpg",
            fileName: "Grosseto mix A6 S 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-mix-a8-mocca",
        name: "Mix A8 Mocca",
        variants: [
          {
            id: "grosseto-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A8 Mocca 1.jpg",
            fileName: "Grosseto mix A8 Mocca 1.jpg"
          },
          {
            id: "grosseto-mix-a8-mocca-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto mix A8 Mocca 2.jpg",
            fileName: "Grosseto mix A8 Mocca 2.jpg"
          }
        ]
      },
      {
        id: "grosseto-szary",
        name: "Szary",
        variants: [
          {
            id: "grosseto-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto/Grosseto szary 1.jpg",
            fileName: "Grosseto szary 1.jpg"
          },
          {
            id: "grosseto-szary-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Grosseto/Grosseto szary 2.jpg",
            fileName: "Grosseto szary 2.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "grosseto-dekor",
    name: "Grosseto Dekor",
    colors: [
      {
        id: "grosseto-dekor-a6-s",
        name: "A6 S",
        variants: [
          {
            id: "grosseto-dekor-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto Dekor/Grosseto Dekor A6 S.jpg",
            fileName: "Grosseto Dekor A6 S.jpg"
          }
        ]
      },
      {
        id: "grosseto-dekor-grafit",
        name: "Grafit",
        variants: [
          {
            id: "grosseto-dekor-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto Dekor/Grosseto Dekor Grafit.jpg",
            fileName: "Grosseto Dekor Grafit.jpg"
          }
        ]
      },
      {
        id: "grosseto-dekor-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "grosseto-dekor-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Grosseto Dekor/Grosseto Dekor mix A6 Marago.jpg",
            fileName: "Grosseto Dekor mix A6 Marago.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "kalifornia",
    name: "Kalifornia",
    colors: [
      {
        id: "kalifornia-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "kalifornia-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia mix A10 Romano.jpg",
            fileName: "Kalifornia mix A10 Romano.jpg"
          }
        ]
      },
      {
        id: "kalifornia-mix-a11-cappuchino",
        name: "Mix A11 Cappuchino",
        variants: [
          {
            id: "kalifornia-mix-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia mix A11 Cappuchino.jpg",
            fileName: "Kalifornia mix A11 Cappuchino.jpg"
          }
        ]
      },
      {
        id: "kalifornia-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "kalifornia-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia mix A12 Frappe.jpg",
            fileName: "Kalifornia mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "kalifornia-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "kalifornia-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia mix A6 Marago.jpg",
            fileName: "Kalifornia mix A6 Marago.jpg"
          }
        ]
      },
      {
        id: "kalifornia-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "kalifornia-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia mix A6 S.jpg",
            fileName: "Kalifornia mix A6 S.jpg"
          }
        ]
      },
      {
        id: "kalifornia-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "kalifornia-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia standard Biały.jpg",
            fileName: "Kalifornia standard Biały.jpg"
          }
        ]
      },
      {
        id: "kalifornia-standard-espresso",
        name: "Standard Espresso",
        variants: [
          {
            id: "kalifornia-standard-espresso-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia standard Espresso.jpg",
            fileName: "Kalifornia standard Espresso.jpg"
          }
        ]
      },
      {
        id: "kalifornia-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "kalifornia-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia standard Grafit.jpg",
            fileName: "Kalifornia standard Grafit.jpg"
          }
        ]
      },
      {
        id: "kalifornia-standard-latte",
        name: "Standard Latte",
        variants: [
          {
            id: "kalifornia-standard-latte-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia standard Latte.jpg",
            fileName: "Kalifornia standard Latte.jpg"
          }
        ]
      },
      {
        id: "kalifornia-standard-lungo",
        name: "Standard Lungo",
        variants: [
          {
            id: "kalifornia-standard-lungo-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Kalifornia/Kalifornia standard Lungo.jpg",
            fileName: "Kalifornia standard Lungo.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "latina",
    name: "Latina",
    colors: [
      {
        id: "latina-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "latina-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina mix A12 Frappe 1.jpg",
            fileName: "Latina mix A12 Frappe 1.jpg"
          },
          {
            id: "latina-mix-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina mix A12 Frappe 2.jpg",
            fileName: "Latina mix A12 Frappe 2.jpg"
          }
        ]
      },
      {
        id: "latina-mix-a4-czekolada",
        name: "Mix A4 Czekolada",
        variants: [
          {
            id: "latina-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina mix A4 Czekolada 1.jpg",
            fileName: "Latina mix A4 Czekolada 1.jpg"
          },
          {
            id: "latina-mix-a4-czekolada-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina mix A4 Czekolada 2.jpg",
            fileName: "Latina mix A4 Czekolada 2.jpg"
          }
        ]
      },
      {
        id: "latina-mix-a5-toffi",
        name: "Mix A5 Toffi",
        variants: [
          {
            id: "latina-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina mix A5 Toffi 1.jpg",
            fileName: "Latina mix A5 Toffi 1.jpg"
          },
          {
            id: "latina-mix-a5-toffi-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina mix A5 Toffi 2.jpg",
            fileName: "Latina mix A5 Toffi 2.jpg"
          }
        ]
      },
      {
        id: "latina-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "latina-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina mix A6 Marago 1.jpg",
            fileName: "Latina mix A6 Marago 1.jpg"
          },
          {
            id: "latina-mix-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina mix A6 Marago 2.jpg",
            fileName: "Latina mix A6 Marago 2.jpg"
          }
        ]
      },
      {
        id: "latina-mix-a8-mocca",
        name: "Mix A8 Mocca",
        variants: [
          {
            id: "latina-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina mix A8 Mocca 1.jpg",
            fileName: "Latina mix A8 Mocca 1.jpg"
          },
          {
            id: "latina-mix-a8-mocca-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina mix A8 Mocca 2.jpg",
            fileName: "Latina mix A8 Mocca 2.jpg"
          }
        ]
      },
      {
        id: "latina-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "latina-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina standard biały 1.jpg",
            fileName: "Latina standard biały 1.jpg"
          },
          {
            id: "latina-standard-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina standard biały 2.jpg",
            fileName: "Latina standard biały 2.jpg"
          }
        ]
      },
      {
        id: "latina-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "latina-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina standard grafit 1.jpg",
            fileName: "Latina standard grafit 1.jpg"
          },
          {
            id: "latina-standard-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina standard grafit 2.jpg",
            fileName: "Latina standard grafit 2.jpg"
          }
        ]
      },
      {
        id: "latina-standard-szary",
        name: "Standard Szary",
        variants: [
          {
            id: "latina-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Latina/Latina standard szary 1.jpg",
            fileName: "Latina standard szary 1.jpg"
          },
          {
            id: "latina-standard-szary-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Latina/Latina standard szary 2.jpg",
            fileName: "Latina standard szary 2.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "moments-aprilla",
    name: "Moments Aprilla",
    colors: [
      {
        id: "moments-aprilla-aprilla-moments-mix-a12",
        name: "Aprilla Moments Mix A12",
        variants: [
          {
            id: "moments-aprilla-aprilla-moments-mix-a12-1",
            name: "Wariant 12",
            texturePath: "/textures/Kostki/Moments Aprilla/Aprilla Moments mix A12.jpg",
            fileName: "Aprilla Moments mix A12.jpg"
          }
        ]
      },
      {
        id: "moments-aprilla-aprilla-moments-mix-a13",
        name: "Aprilla Moments Mix A13",
        variants: [
          {
            id: "moments-aprilla-aprilla-moments-mix-a13-1",
            name: "Wariant 13",
            texturePath: "/textures/Kostki/Moments Aprilla/Aprilla Moments mix A13.jpg",
            fileName: "Aprilla Moments mix A13.jpg"
          }
        ]
      },
      {
        id: "moments-aprilla-aprilla-moments-mix-a6-s",
        name: "Aprilla Moments Mix A6 S",
        variants: [
          {
            id: "moments-aprilla-aprilla-moments-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Aprilla/Aprilla Moments mix A6 S.jpg",
            fileName: "Aprilla Moments mix A6 S.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "moments-kalifornia",
    name: "Moments Kalifornia",
    colors: [
      {
        id: "moments-kalifornia-kalifornia-moments-mix-a12",
        name: "Kalifornia Moments Mix A12",
        variants: [
          {
            id: "moments-kalifornia-kalifornia-moments-mix-a12-1",
            name: "Wariant 12",
            texturePath: "/textures/Kostki/Moments Kalifornia/Kalifornia Moments mix A12.jpg",
            fileName: "Kalifornia Moments mix A12.jpg"
          }
        ]
      },
      {
        id: "moments-kalifornia-kalifornia-moments-mix-a13",
        name: "Kalifornia Moments Mix A13",
        variants: [
          {
            id: "moments-kalifornia-kalifornia-moments-mix-a13-1",
            name: "Wariant 13",
            texturePath: "/textures/Kostki/Moments Kalifornia/Kalifornia Moments mix A13.jpg",
            fileName: "Kalifornia Moments mix A13.jpg"
          }
        ]
      },
      {
        id: "moments-kalifornia-kalifornia-moments-mix-a6-s",
        name: "Kalifornia Moments Mix A6 S",
        variants: [
          {
            id: "moments-kalifornia-kalifornia-moments-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Kalifornia/Kalifornia Moments mix A6 S.jpg",
            fileName: "Kalifornia Moments mix A6 S.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "moments-real-living",
    name: "Moments Real Living",
    colors: [
      {
        id: "moments-real-living-real-living-moments-mix-a12-frappe",
        name: "Real Living Moments Mix A12 Frappe",
        variants: [
          {
            id: "moments-real-living-real-living-moments-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Real Living/Real Living Moments mix A12 Frappe.jpg",
            fileName: "Real Living Moments mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "moments-real-living-real-living-moments-mix-a6-s",
        name: "Real Living Moments Mix A6 S",
        variants: [
          {
            id: "moments-real-living-real-living-moments-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Real Living/Real Living Moments mix A6 S.jpg",
            fileName: "Real Living Moments mix A6 S.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "moments-real-nature",
    name: "Moments Real Nature",
    colors: [
      {
        id: "moments-real-nature-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "moments-real-nature-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Real Nature/Moments Real Nature mix A12 Frappe.jpg",
            fileName: "Moments Real Nature mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "moments-real-nature-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "moments-real-nature-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Real Nature/Moments Real Nature mix A6 S.jpg",
            fileName: "Moments Real Nature mix A6 S.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "moments-rimini",
    name: "Moments Rimini",
    colors: [
      {
        id: "moments-rimini-rimini-moments-mix-a12-frappe",
        name: "Rimini Moments Mix A12 Frappe",
        variants: [
          {
            id: "moments-rimini-rimini-moments-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Rimini/Rimini Moments mix A12 Frappe.jpg",
            fileName: "Rimini Moments mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "moments-rimini-rimini-moments-mix-a13-caffe",
        name: "Rimini Moments Mix A13 Caffe",
        variants: [
          {
            id: "moments-rimini-rimini-moments-mix-a13-caffe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Rimini/Rimini Moments mix A13 Caffe.jpg",
            fileName: "Rimini Moments mix A13 Caffe.jpg"
          }
        ]
      },
      {
        id: "moments-rimini-rimini-moments-mix-a6-s",
        name: "Rimini Moments Mix A6 S",
        variants: [
          {
            id: "moments-rimini-rimini-moments-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Rimini/Rimini Moments mix A6 S.jpg",
            fileName: "Rimini Moments mix A6 S.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "moments-toronto",
    name: "Moments Toronto",
    colors: [
      {
        id: "moments-toronto-toronto-moments-mix-a12",
        name: "Toronto Moments Mix A12",
        variants: [
          {
            id: "moments-toronto-toronto-moments-mix-a12-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Toronto/Toronto Moments mix A12 (1).jpg",
            fileName: "Toronto Moments mix A12 (1).jpg"
          },
          {
            id: "moments-toronto-toronto-moments-mix-a12-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Moments Toronto/Toronto Moments mix A12 (2).jpg",
            fileName: "Toronto Moments mix A12 (2).jpg"
          }
        ]
      },
      {
        id: "moments-toronto-toronto-moments-mix-a6-s",
        name: "Toronto Moments Mix A6 S",
        variants: [
          {
            id: "moments-toronto-toronto-moments-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Moments Toronto/Toronto Moments mix A6 S (1).jpg",
            fileName: "Toronto Moments mix A6 S (1).jpg"
          },
          {
            id: "moments-toronto-toronto-moments-mix-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Moments Toronto/Toronto Moments mix A6 S (2).jpg",
            fileName: "Toronto Moments mix A6 S (2).jpg"
          }
        ]
      }
    ]
  },
  {
    id: "nevada",
    name: "Nevada",
    colors: [
      {
        id: "nevada-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "nevada-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada mix A10 Romano.jpg",
            fileName: "Nevada mix A10 Romano.jpg"
          }
        ]
      },
      {
        id: "nevada-mix-a11-cappuchino",
        name: "Mix A11 Cappuchino",
        variants: [
          {
            id: "nevada-mix-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada mix A11 Cappuchino.jpg",
            fileName: "Nevada mix A11 Cappuchino.jpg"
          }
        ]
      },
      {
        id: "nevada-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "nevada-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada mix A12 Frappe.jpg",
            fileName: "Nevada mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "nevada-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "nevada-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada mix A6 Marago.jpg",
            fileName: "Nevada mix A6 Marago.jpg"
          }
        ]
      },
      {
        id: "nevada-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "nevada-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada mix A6 S.jpg",
            fileName: "Nevada mix A6 S.jpg"
          }
        ]
      },
      {
        id: "nevada-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "nevada-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada standard biały.jpg",
            fileName: "Nevada standard biały.jpg"
          }
        ]
      },
      {
        id: "nevada-standard-espresso",
        name: "Standard Espresso",
        variants: [
          {
            id: "nevada-standard-espresso-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada standard espresso.jpg",
            fileName: "Nevada standard espresso.jpg"
          }
        ]
      },
      {
        id: "nevada-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "nevada-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada standard grafit.jpg",
            fileName: "Nevada standard grafit.jpg"
          }
        ]
      },
      {
        id: "nevada-standard-latte",
        name: "Standard Latte",
        variants: [
          {
            id: "nevada-standard-latte-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada standard latte.jpg",
            fileName: "Nevada standard latte.jpg"
          }
        ]
      },
      {
        id: "nevada-standard-lungo",
        name: "Standard Lungo",
        variants: [
          {
            id: "nevada-standard-lungo-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Nevada/Nevada standard lungo.jpg",
            fileName: "Nevada standard lungo.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "pireus",
    name: "Pireus",
    colors: [
      {
        id: "pireus-mix-12-frappe",
        name: "Mix 12 Frappe",
        variants: [
          {
            id: "pireus-mix-12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus mix 12 Frappe.jpg",
            fileName: "Pireus mix 12 Frappe.jpg"
          }
        ]
      },
      {
        id: "pireus-mix-a4-czekolada",
        name: "Mix A4 Czekolada",
        variants: [
          {
            id: "pireus-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus mix A4 Czekolada.jpg",
            fileName: "Pireus mix A4 Czekolada.jpg"
          }
        ]
      },
      {
        id: "pireus-mix-a5-toffi",
        name: "Mix A5 Toffi",
        variants: [
          {
            id: "pireus-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus mix A5 Toffi.jpg",
            fileName: "Pireus mix A5 Toffi.jpg"
          }
        ]
      },
      {
        id: "pireus-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "pireus-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus mix A6 Marago.jpg",
            fileName: "Pireus mix A6 Marago.jpg"
          }
        ]
      },
      {
        id: "pireus-mix-a8-mocca",
        name: "Mix A8 Mocca",
        variants: [
          {
            id: "pireus-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus mix A8 Mocca.jpg",
            fileName: "Pireus mix A8 Mocca.jpg"
          }
        ]
      },
      {
        id: "pireus-plukany-bialy",
        name: "Płukany Biały",
        variants: [
          {
            id: "pireus-plukany-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus płukany Biały.jpg",
            fileName: "Pireus płukany Biały.jpg"
          }
        ]
      },
      {
        id: "pireus-plukany-grafit",
        name: "Płukany Grafit",
        variants: [
          {
            id: "pireus-plukany-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus płukany Grafit.jpg",
            fileName: "Pireus płukany Grafit.jpg"
          }
        ]
      },
      {
        id: "pireus-plukany-szary",
        name: "Płukany Szary",
        variants: [
          {
            id: "pireus-plukany-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus płukany Szary.jpg",
            fileName: "Pireus płukany Szary.jpg"
          }
        ]
      },
      {
        id: "pireus-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "pireus-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus standard Grafit.jpg",
            fileName: "Pireus standard Grafit.jpg"
          }
        ]
      },
      {
        id: "pireus-standard-szary",
        name: "Standard Szary",
        variants: [
          {
            id: "pireus-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Pireus/Pireus standard Szary.jpg",
            fileName: "Pireus standard Szary.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "ravenna",
    name: "Ravenna",
    colors: [
      {
        id: "ravenna-ravena-mix-a10-romano",
        name: "Ravena Mix A10 Romano",
        variants: [
          {
            id: "ravenna-ravena-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A10 Romano.jpg",
            fileName: "Ravena mix A10 Romano.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a11-cappuchino",
        name: "Ravena Mix A11 Cappuchino",
        variants: [
          {
            id: "ravenna-ravena-mix-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A11 Cappuchino.jpg",
            fileName: "Ravena mix A11 Cappuchino.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a12-frappe",
        name: "Ravena Mix A12 Frappe",
        variants: [
          {
            id: "ravenna-ravena-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A12 Frappe.jpg",
            fileName: "Ravena mix A12 Frappe.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a4-czekolada",
        name: "Ravena Mix A4 Czekolada",
        variants: [
          {
            id: "ravenna-ravena-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A4 Czekolada.jpg",
            fileName: "Ravena mix A4 Czekolada.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a5-toffi",
        name: "Ravena Mix A5 Toffi",
        variants: [
          {
            id: "ravenna-ravena-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A5 Toffi.jpg",
            fileName: "Ravena mix A5 Toffi.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a6-marago",
        name: "Ravena Mix A6 Marago",
        variants: [
          {
            id: "ravenna-ravena-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A6 Marago.jpg",
            fileName: "Ravena mix A6 Marago.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a6-s",
        name: "Ravena Mix A6 S",
        variants: [
          {
            id: "ravenna-ravena-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A6 S.jpg",
            fileName: "Ravena mix A6 S.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-mix-a8-mocca",
        name: "Ravena Mix A8 Mocca",
        variants: [
          {
            id: "ravenna-ravena-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena mix A8 Mocca.jpg",
            fileName: "Ravena mix A8 Mocca.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-plukany-bialy",
        name: "Ravena Płukany Biały",
        variants: [
          {
            id: "ravenna-ravena-plukany-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena płukany biały.jpg",
            fileName: "Ravena płukany biały.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-plukany-grafit",
        name: "Ravena Płukany Grafit",
        variants: [
          {
            id: "ravenna-ravena-plukany-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena płukany grafit.jpg",
            fileName: "Ravena płukany grafit.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-plukany-szary",
        name: "Ravena Płukany Szary",
        variants: [
          {
            id: "ravenna-ravena-plukany-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena płukany szary.jpg",
            fileName: "Ravena płukany szary.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-plukany-zolto-kremowy",
        name: "Ravena Płukany Żółto Kremowy",
        variants: [
          {
            id: "ravenna-ravena-plukany-zolto-kremowy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena płukany żółto kremowy.jpg",
            fileName: "Ravena płukany żółto kremowy.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-standard-bialy",
        name: "Ravena Standard Biały",
        variants: [
          {
            id: "ravenna-ravena-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena standard biały.jpg",
            fileName: "Ravena standard biały.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-standard-grafit",
        name: "Ravena Standard Grafit",
        variants: [
          {
            id: "ravenna-ravena-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena standard grafit.jpg",
            fileName: "Ravena standard grafit.jpg"
          }
        ]
      },
      {
        id: "ravenna-ravena-standard-szary",
        name: "Ravena Standard Szary",
        variants: [
          {
            id: "ravenna-ravena-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Ravenna/Ravena standard szary.jpg",
            fileName: "Ravena standard szary.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "rosano",
    name: "Rosano",
    colors: [
      {
        id: "rosano-zlota-jesien-a1",
        name: "Złota Jesień A1",
        variants: [
          {
            id: "rosano-zlota-jesien-a1-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano Złota Jesień A1 1.jpg",
            fileName: "Rosano Złota Jesień A1 1.jpg"
          },
          {
            id: "rosano-zlota-jesien-a1-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano Złota Jesień A1 2.jpg",
            fileName: "Rosano Złota Jesień A1 2.jpg"
          },
          {
            id: "rosano-zlota-jesien-a1-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano Złota Jesień A1 3.jpg",
            fileName: "Rosano Złota Jesień A1 3.jpg"
          }
        ]
      },
      {
        id: "rosano-zlota-jesien-a3",
        name: "Złota Jesień A3",
        variants: [
          {
            id: "rosano-zlota-jesien-a3-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano Złota Jesień A3 1.jpg",
            fileName: "Rosano Złota Jesień A3 1.jpg"
          },
          {
            id: "rosano-zlota-jesien-a3-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano Złota Jesień A3 2.jpg",
            fileName: "Rosano Złota Jesień A3 2.jpg"
          },
          {
            id: "rosano-zlota-jesien-a3-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano Złota Jesień A3 3.jpg",
            fileName: "Rosano Złota Jesień A3 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "rosano-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A10 Romano 1.jpg",
            fileName: "Rosano mix A10 Romano 1.jpg"
          },
          {
            id: "rosano-mix-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A10 Romano 2.jpg",
            fileName: "Rosano mix A10 Romano 2.jpg"
          },
          {
            id: "rosano-mix-a10-romano-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A10 Romano 3.jpg",
            fileName: "Rosano mix A10 Romano 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a11-cappuchino",
        name: "Mix A11 Cappuchino",
        variants: [
          {
            id: "rosano-mix-a11-cappuchino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A11 Cappuchino 1.jpg",
            fileName: "Rosano mix A11 Cappuchino 1.jpg"
          },
          {
            id: "rosano-mix-a11-cappuchino-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A11 Cappuchino 2.jpg",
            fileName: "Rosano mix A11 Cappuchino 2.jpg"
          },
          {
            id: "rosano-mix-a11-cappuchino-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A11 Cappuchino 3.jpg",
            fileName: "Rosano mix A11 Cappuchino 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "rosano-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A12 Frappe 1.jpg",
            fileName: "Rosano mix A12 Frappe 1.jpg"
          },
          {
            id: "rosano-mix-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A12 Frappe 2.jpg",
            fileName: "Rosano mix A12 Frappe 2.jpg"
          },
          {
            id: "rosano-mix-a12-frappe-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A12 Frappe 3.jpg",
            fileName: "Rosano mix A12 Frappe 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a4-czekolada",
        name: "Mix A4 Czekolada",
        variants: [
          {
            id: "rosano-mix-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A4 Czekolada 1.jpg",
            fileName: "Rosano mix A4 Czekolada 1.jpg"
          },
          {
            id: "rosano-mix-a4-czekolada-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A4 Czekolada 2.jpg",
            fileName: "Rosano mix A4 Czekolada 2.jpg"
          },
          {
            id: "rosano-mix-a4-czekolada-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A4 Czekolada 3.jpg",
            fileName: "Rosano mix A4 Czekolada 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a5-toffi",
        name: "Mix A5 Toffi",
        variants: [
          {
            id: "rosano-mix-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A5 Toffi 1.jpg",
            fileName: "Rosano mix A5 Toffi 1.jpg"
          },
          {
            id: "rosano-mix-a5-toffi-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A5 Toffi 2.jpg",
            fileName: "Rosano mix A5 Toffi 2.jpg"
          },
          {
            id: "rosano-mix-a5-toffi-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A5 Toffi 3.jpg",
            fileName: "Rosano mix A5 Toffi 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a6-marago",
        name: "Mix A6 Marago",
        variants: [
          {
            id: "rosano-mix-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A6 Marago 1.jpg",
            fileName: "Rosano mix A6 Marago 1.jpg"
          },
          {
            id: "rosano-mix-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A6 Marago 2.jpg",
            fileName: "Rosano mix A6 Marago 2.jpg"
          },
          {
            id: "rosano-mix-a6-marago-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A6 Marago 3.jpg",
            fileName: "Rosano mix A6 Marago 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "rosano-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A6 S 1.jpg",
            fileName: "Rosano mix A6 S 1.jpg"
          },
          {
            id: "rosano-mix-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A6 S 2.jpg",
            fileName: "Rosano mix A6 S 2.jpg"
          },
          {
            id: "rosano-mix-a6-s-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A6 S 3.jpg",
            fileName: "Rosano mix A6 S 3.jpg"
          }
        ]
      },
      {
        id: "rosano-mix-a8-mocca",
        name: "Mix A8 Mocca",
        variants: [
          {
            id: "rosano-mix-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A8 Mocca 1.jpg",
            fileName: "Rosano mix A8 Mocca 1.jpg"
          },
          {
            id: "rosano-mix-a8-mocca-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A8 Mocca 2.jpg",
            fileName: "Rosano mix A8 Mocca 2.jpg"
          },
          {
            id: "rosano-mix-a8-mocca-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano mix A8 Mocca 3.jpg",
            fileName: "Rosano mix A8 Mocca 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-bialy",
        name: "Płukany Biały",
        variants: [
          {
            id: "rosano-plukany-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany biały 1.jpg",
            fileName: "Rosano płukany biały 1.jpg"
          },
          {
            id: "rosano-plukany-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany biały 2.jpg",
            fileName: "Rosano płukany biały 2.jpg"
          },
          {
            id: "rosano-plukany-bialy-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany biały 3.jpg",
            fileName: "Rosano płukany biały 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-braz",
        name: "Płukany Brąz",
        variants: [
          {
            id: "rosano-plukany-braz-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany brąz 1.jpg",
            fileName: "Rosano płukany brąz 1.jpg"
          },
          {
            id: "rosano-plukany-braz-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany brąz 2.jpg",
            fileName: "Rosano płukany brąz 2.jpg"
          },
          {
            id: "rosano-plukany-braz-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany brąz 3.jpg",
            fileName: "Rosano płukany brąz 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-grafit",
        name: "Płukany Grafit",
        variants: [
          {
            id: "rosano-plukany-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany grafit 1.jpg",
            fileName: "Rosano płukany grafit 1.jpg"
          },
          {
            id: "rosano-plukany-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany grafit 2.jpg",
            fileName: "Rosano płukany grafit 2.jpg"
          },
          {
            id: "rosano-plukany-grafit-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany grafit 3.jpg",
            fileName: "Rosano płukany grafit 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-szary",
        name: "Płukany Szary",
        variants: [
          {
            id: "rosano-plukany-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany szary 1.jpg",
            fileName: "Rosano płukany szary 1.jpg"
          },
          {
            id: "rosano-plukany-szary-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany szary 2.jpg",
            fileName: "Rosano płukany szary 2.jpg"
          },
          {
            id: "rosano-plukany-szary-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany szary 3.jpg",
            fileName: "Rosano płukany szary 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-losos",
        name: "Płukany Łosoś",
        variants: [
          {
            id: "rosano-plukany-losos-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany łosoś 1.jpg",
            fileName: "Rosano płukany łosoś 1.jpg"
          },
          {
            id: "rosano-plukany-losos-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany łosoś 2.jpg",
            fileName: "Rosano płukany łosoś 2.jpg"
          },
          {
            id: "rosano-plukany-losos-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany łosoś 3.jpg",
            fileName: "Rosano płukany łosoś 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-zolto-kremowy",
        name: "Płukany Żółto-kremowy",
        variants: [
          {
            id: "rosano-plukany-zolto-kremowy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany żółto-kremowy 1.jpg",
            fileName: "Rosano płukany żółto-kremowy 1.jpg"
          },
          {
            id: "rosano-plukany-zolto-kremowy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany żółto-kremowy 2.jpg",
            fileName: "Rosano płukany żółto-kremowy 2.jpg"
          },
          {
            id: "rosano-plukany-zolto-kremowy-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany żółto-kremowy 3.jpg",
            fileName: "Rosano płukany żółto-kremowy 3.jpg"
          }
        ]
      },
      {
        id: "rosano-plukany-zolty",
        name: "Płukany Żółty",
        variants: [
          {
            id: "rosano-plukany-zolty-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany żółty 1.jpg",
            fileName: "Rosano płukany żółty 1.jpg"
          },
          {
            id: "rosano-plukany-zolty-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany żółty 2.jpg",
            fileName: "Rosano płukany żółty 2.jpg"
          },
          {
            id: "rosano-plukany-zolty-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano płukany żółty 3.jpg",
            fileName: "Rosano płukany żółty 3.jpg"
          }
        ]
      },
      {
        id: "rosano-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "rosano-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano standard biały 1.jpg",
            fileName: "Rosano standard biały 1.jpg"
          },
          {
            id: "rosano-standard-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano standard biały 2.jpg",
            fileName: "Rosano standard biały 2.jpg"
          },
          {
            id: "rosano-standard-bialy-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano standard biały 3.jpg",
            fileName: "Rosano standard biały 3.jpg"
          }
        ]
      },
      {
        id: "rosano-standard-bialy-forte",
        name: "Standard Biały Forte",
        variants: [
          {
            id: "rosano-standard-bialy-forte-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano standard biały forte 1.jpg",
            fileName: "Rosano standard biały forte 1.jpg"
          },
          {
            id: "rosano-standard-bialy-forte-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano standard biały forte 2.jpg",
            fileName: "Rosano standard biały forte 2.jpg"
          },
          {
            id: "rosano-standard-bialy-forte-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano standard biały forte 3.jpg",
            fileName: "Rosano standard biały forte 3.jpg"
          }
        ]
      },
      {
        id: "rosano-standard-grafit",
        name: "Standard Grafit",
        variants: [
          {
            id: "rosano-standard-grafit-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano standard grafit 1.jpg",
            fileName: "Rosano standard grafit 1.jpg"
          },
          {
            id: "rosano-standard-grafit-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano standard grafit 2.jpg",
            fileName: "Rosano standard grafit 2.jpg"
          },
          {
            id: "rosano-standard-grafit-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano standard grafit 3.jpg",
            fileName: "Rosano standard grafit 3.jpg"
          }
        ]
      },
      {
        id: "rosano-standard-szary",
        name: "Standard Szary",
        variants: [
          {
            id: "rosano-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Rosano/Rosano standard szary 1.jpg",
            fileName: "Rosano standard szary 1.jpg"
          },
          {
            id: "rosano-standard-szary-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Rosano/Rosano standard szary 2.jpg",
            fileName: "Rosano standard szary 2.jpg"
          },
          {
            id: "rosano-standard-szary-3",
            name: "Wariant 3",
            texturePath: "/textures/Kostki/Rosano/Rosano standard szary 3.jpg",
            fileName: "Rosano standard szary 3.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "slavia",
    name: "Slavia",
    colors: [
      {
        id: "slavia-a12-frappe",
        name: "A12 Frappe",
        variants: [
          {
            id: "slavia-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Slavia/Slavia A12 Frappe 1.jpg",
            fileName: "Slavia A12 Frappe 1.jpg"
          },
          {
            id: "slavia-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Slavia/Slavia A12 Frappe 2.jpg",
            fileName: "Slavia A12 Frappe 2.jpg"
          }
        ]
      },
      {
        id: "slavia-a4-czekolada",
        name: "A4 Czekolada",
        variants: [
          {
            id: "slavia-a4-czekolada-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Slavia/Slavia A4 czekolada 1.jpg",
            fileName: "Slavia A4 czekolada 1.jpg"
          },
          {
            id: "slavia-a4-czekolada-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Slavia/Slavia A4 czekolada 2.jpg",
            fileName: "Slavia A4 czekolada 2.jpg"
          }
        ]
      },
      {
        id: "slavia-a5-toffi",
        name: "A5 Toffi",
        variants: [
          {
            id: "slavia-a5-toffi-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Slavia/Slavia A5 Toffi 1.jpg",
            fileName: "Slavia A5 Toffi 1.jpg"
          },
          {
            id: "slavia-a5-toffi-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Slavia/Slavia A5 Toffi 2.jpg",
            fileName: "Slavia A5 Toffi 2.jpg"
          }
        ]
      },
      {
        id: "slavia-a6-marago",
        name: "A6 Marago",
        variants: [
          {
            id: "slavia-a6-marago-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Slavia/Slavia A6 Marago 1.jpg",
            fileName: "Slavia A6 Marago 1.jpg"
          },
          {
            id: "slavia-a6-marago-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Slavia/Slavia A6 Marago 2.jpg",
            fileName: "Slavia A6 Marago 2.jpg"
          }
        ]
      },
      {
        id: "slavia-a8-mocca",
        name: "A8 Mocca",
        variants: [
          {
            id: "slavia-a8-mocca-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Slavia/Slavia A8 Mocca 1.jpg",
            fileName: "Slavia A8 Mocca 1.jpg"
          },
          {
            id: "slavia-a8-mocca-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Slavia/Slavia A8 Mocca 2.jpg",
            fileName: "Slavia A8 Mocca 2.jpg"
          }
        ]
      }
    ]
  },
  {
    id: "toronto",
    name: "Toronto",
    colors: [
      {
        id: "toronto-mix-a10-romano",
        name: "Mix A10 Romano",
        variants: [
          {
            id: "toronto-mix-a10-romano-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A10 Romano (1).jpg",
            fileName: "Toronto mix A10 Romano (1).jpg"
          },
          {
            id: "toronto-mix-a10-romano-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A10 Romano (2).jpg",
            fileName: "Toronto mix A10 Romano (2).jpg"
          }
        ]
      },
      {
        id: "toronto-mix-a11-cappucino",
        name: "Mix A11 Cappucino",
        variants: [
          {
            id: "toronto-mix-a11-cappucino-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A11 Cappucino (1).jpg",
            fileName: "Toronto mix A11 Cappucino (1).jpg"
          },
          {
            id: "toronto-mix-a11-cappucino-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A11 Cappucino (2).jpg",
            fileName: "Toronto mix A11 Cappucino (2).jpg"
          }
        ]
      },
      {
        id: "toronto-mix-a12-frappe",
        name: "Mix A12 Frappe",
        variants: [
          {
            id: "toronto-mix-a12-frappe-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A12 Frappe (1).jpg",
            fileName: "Toronto mix A12 Frappe (1).jpg"
          },
          {
            id: "toronto-mix-a12-frappe-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A12 Frappe (2).jpg",
            fileName: "Toronto mix A12 Frappe (2).jpg"
          }
        ]
      },
      {
        id: "toronto-mix-a6-s",
        name: "Mix A6 S",
        variants: [
          {
            id: "toronto-mix-a6-s-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A6 S (1).jpg",
            fileName: "Toronto mix A6 S (1).jpg"
          },
          {
            id: "toronto-mix-a6-s-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto mix A6 S (2).jpg",
            fileName: "Toronto mix A6 S (2).jpg"
          }
        ]
      },
      {
        id: "toronto-standard-bialy",
        name: "Standard Biały",
        variants: [
          {
            id: "toronto-standard-bialy-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto standard biały (1).jpg",
            fileName: "Toronto standard biały (1).jpg"
          },
          {
            id: "toronto-standard-bialy-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto standard biały (2).jpg",
            fileName: "Toronto standard biały (2).jpg"
          }
        ]
      },
      {
        id: "toronto-standard-espresso",
        name: "Standard Espresso",
        variants: [
          {
            id: "toronto-standard-espresso-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto standard espresso (1).jpg",
            fileName: "Toronto standard espresso (1).jpg"
          },
          {
            id: "toronto-standard-espresso-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto standard espresso (2).jpg",
            fileName: "Toronto standard espresso (2).jpg"
          }
        ]
      },
      {
        id: "toronto-standard-grafik",
        name: "Standard Grafik",
        variants: [
          {
            id: "toronto-standard-grafik-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto standard grafik (1).jpg",
            fileName: "Toronto standard grafik (1).jpg"
          },
          {
            id: "toronto-standard-grafik-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto standard grafik (2).jpg",
            fileName: "Toronto standard grafik (2).jpg"
          }
        ]
      },
      {
        id: "toronto-standard-latte",
        name: "Standard Latte",
        variants: [
          {
            id: "toronto-standard-latte-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto standard latte (1).jpg",
            fileName: "Toronto standard latte (1).jpg"
          },
          {
            id: "toronto-standard-latte-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto standard latte (2).jpg",
            fileName: "Toronto standard latte (2).jpg"
          }
        ]
      },
      {
        id: "toronto-standard-lungo",
        name: "Standard Lungo",
        variants: [
          {
            id: "toronto-standard-lungo-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto standard lungo (1).jpg",
            fileName: "Toronto standard lungo (1).jpg"
          },
          {
            id: "toronto-standard-lungo-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto standard lungo (2).jpg",
            fileName: "Toronto standard lungo (2).jpg"
          }
        ]
      },
      {
        id: "toronto-standard-szary",
        name: "Standard Szary",
        variants: [
          {
            id: "toronto-standard-szary-1",
            name: "Wariant 1",
            texturePath: "/textures/Kostki/Toronto/Toronto standard szary (1).jpg",
            fileName: "Toronto standard szary (1).jpg"
          },
          {
            id: "toronto-standard-szary-2",
            name: "Wariant 2",
            texturePath: "/textures/Kostki/Toronto/Toronto standard szary (2).jpg",
            fileName: "Toronto standard szary (2).jpg"
          }
        ]
      }
    ]
  }
]

// Funkcja pomocnicza do znajdowania wariantu po ID
export function findTileVariant(variantId: string): TileVariant | null {
  for (const model of tileModels) {
    for (const color of model.colors) {
      const variant = color.variants.find(v => v.id === variantId)
      if (variant) return variant
    }
  }
  return null
}

// Funkcja pomocnicza do znajdowania wszystkich wariantów dla danego modelu
export function getVariantsForModel(modelId: string): TileVariant[] {
  const model = tileModels.find(m => m.id === modelId)
  if (!model) return []
  
  return model.colors.flatMap(color => color.variants)
}

// Funkcja pomocnicza do znajdowania wszystkich wariantów dla danego koloru
export function getVariantsForColor(modelId: string, colorId: string): TileVariant[] {
  const model = tileModels.find(m => m.id === modelId)
  if (!model) return []
  
  const color = model.colors.find(c => c.id === colorId)
  if (!color) return []
  
  return color.variants
}
